import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";

// LandingPage chunk is webpackPreload-ed: browser fetches it in parallel with
// main.js so it is ready by the time React evaluates the route — cuts one round-trip
// off the LCP critical path on mobile.
const LandingPage = lazy(() => import(/* webpackPreload: true */ "./pages/LandingPage"));
const TeamPage = lazy(() => import("./pages/TeamPage"));
const TeamMemberDetail = lazy(() => import("./pages/DetailTeamMemberPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

const App = () => {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<div className="min-h-screen" />}>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/team/:memberId" element={<TeamMemberDetail />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
};

export default App;
